import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    Grid,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Divider,
    IconButton,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Pagination,
    Alert,
    AlertTitle,
    LinearProgress,
    InputAdornment,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from '@mui/material';
import { Store } from 'react-notifications-component';
import {
    AddCircleOutline as AddIcon,
    CheckCircle as AcceptedIcon,
    Cancel as RejectedIcon,
    Send as SentIcon,
    Business as BrandIcon,
    CloudUpload as UploadIcon,
    InfoOutlined as InfoIcon,
    LibraryBooks as SectionIcon,
    FilePresent as FileIcon,
    ErrorOutline as ErrorIcon,
    Search as SearchIcon,
    Edit as EditIcon,
    Close as CloseIcon,
    ReportProblem as ReportProblemIcon,
    Timeline as TimelineIcon,
    FactCheck as FactCheckIcon,
    Gavel as GavelIcon,
    HourglassTop as HourglassIcon,
    Refresh as RefreshIcon
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { registrarSolicitud, obtenerSolicitudes, actualizarSolicitud } from '../../../redux/DucksBeneficiario/InformacionComercialDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { hostInformacionComercial } from '../../../configuraciones';

// Filtros de Trazabilidad por Estatus
const FILTROS_TRAZABILIDAD = [
    { key: 'TODOS', label: 'Todas las Solicitudes', icon: <TimelineIcon fontSize="small" />, color: '#2b2b2b' },
    { key: 'E1_ENVIADA_ASOCIADO', label: '1. Enviadas AC', icon: <SentIcon fontSize="small" />, color: '#1976d2' },
    { key: 'E2_RECHAZADA_AC', label: '2. Rechazadas AC', icon: <RejectedIcon fontSize="small" />, color: '#d32f2f' },
    { key: 'E3_ACEPTADA_AC', label: '3. Aceptadas AC', icon: <FactCheckIcon fontSize="small" />, color: '#0288d1' },
    { key: 'E4_E5_REVISION_IC', label: '4. En Revisión IC', icon: <HourglassIcon fontSize="small" />, color: '#ed6c02' },
    { key: 'E6_RECHAZADA_IC', label: '5. Rechazadas IC', icon: <RejectedIcon fontSize="small" />, color: '#d32f2f' },
    { key: 'E7_ACEPTADA_CON_INFORME', label: '6. Informe Aprobado', icon: <AcceptedIcon fontSize="small" />, color: '#2e7d32' },
    { key: 'E8_E9_UI', label: '7. Dictamen Final UI', icon: <GavelIcon fontSize="small" />, color: '#1b5e20' }
];

const InformacionComercial = () => {
    const [estatusFiltro, setEstatusFiltro] = useState('TODOS');
    const [searchTerm, setSearchTerm] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const currentUser = useSelector(store => store.Usuario.data);
    const userId = currentUser?.user?.[0]?.id || currentUser?.user?.[0]?.idlogin || currentUser?.idlogin || currentUser?.id;
    const { solicitudes, pagination, counts = {}, loading: loadingInfo } = useSelector(store => store.informacionComercial);
    const [cliente, setCliente] = useState(null);

    const [formData, setFormData] = useState({
        id_marca_cliente: '',
        tipoSolicitud: '',
        pais: '',
        comentarios: '',
        motivos: {
            cambioPresentacion: false,
            cambioPais: false,
            cambioDestino: false,
            otros: false
        },
        documentos: [],
        pagoPdf: null,
        etiquetasPdf: null
    });

    const handleFilterChange = (filtroKey) => {
        setEstatusFiltro(filtroKey);
        setPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setPage(1);
    };

    const handleOpenModal = () => {
        setIsEditing(false);
        setSelectedBrand(null);
        setFormData({
            id_marca_cliente: '',
            tipoSolicitud: '',
            pais: '',
            comentarios: '',
            motivos: {
                cambioPresentacion: false,
                cambioPais: false,
                cambioDestino: false,
                otros: false
            },
            documentos: [],
            pagoPdf: null,
            etiquetasPdf: null
        });
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEditing(false);
        setFormData({
            id_marca_cliente: '',
            tipoSolicitud: '',
            pais: '',
            comentarios: '',
            motivos: {
                cambioPresentacion: false,
                cambioPais: false,
                cambioDestino: false,
                otros: false
            },
            documentos: [],
            pagoPdf: null,
            etiquetasPdf: null
        });
    };

    const handleOpenDetailModal = (brand) => {
        setSelectedBrand(brand);
        setOpenDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setOpenDetailModal(false);
        setSelectedBrand(null);
    };

    const handleEditRequest = (brand) => {
        setSelectedBrand(brand);
        setFormData({
            id_marca_cliente: brand.id_marca_cliente || '',
            tipoSolicitud: brand.tipo_informe === 'Exportaci_n' ? 'Exportación' : (brand.tipo_informe || 'Nacional'),
            pais: brand.pais || '',
            comentarios: brand.comentarios_adicionales || '',
            motivos: {
                cambioPresentacion: Boolean(brand.cambio_presentacion),
                cambioPais: Boolean(brand.cambio_pais),
                cambioDestino: Boolean(brand.cambio_destino),
                otros: Boolean(brand.otros),
            },
            documentos: brand.solicitud_documentacion || brand.archivos || [],
            pagoPdf: null,
            etiquetasPdf: null
        });
        setOpenDetailModal(false);
        setIsEditing(true);
        setOpenModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            motivos: {
                ...prev.motivos,
                [name]: checked
            }
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        if (file) {
            const newDoc = {
                tipo_documento: name === 'pagoPdf' ? 'COMPROBANTE_PAGO' : 'JUEGO_ETIQUETAS',
                nombre_archivo: file.name,
                url_archivo: `temp_url_${file.name}`
            };
            setFormData(prev => ({
                ...prev,
                [name]: file,
                documentos: [...prev.documentos.filter(d => d.tipo_documento !== newDoc.tipo_documento), newDoc]
            }));
        }
    };

    const isSolicitudRechazada = (brand) => {
        if (!brand) return false;
        return brand.is_rechazada || ['RECHAZADA', 'E2_RECHAZADA_AC', 'E6_RECHAZADA_IC', 'E8_RECHAZADA_UI'].includes(brand.estatus);
    };

    const getObservacionesRechazo = (brand) => {
        if (!brand) return '';
        return (
            brand.observaciones_ac ||
            brand.observaciones_ic ||
            brand.observaciones_ui ||
            brand.observaciones_rechazo ||
            brand.motivo_rechazo ||
            ''
        );
    };

    const getEtapaRechazoLabel = (estatus) => {
        switch (estatus) {
            case 'E2_RECHAZADA_AC':
                return 'Atención a Clientes';
            case 'E6_RECHAZADA_IC':
                return 'Información Comercial';
            case 'E8_RECHAZADA_UI':
                return 'Unidad de Inspección';
            default:
                return 'Revisión Oficial';
        }
    };

    const getStatusBadge = (brand) => {
        const traz = brand?.trazabilidad;
        const est = brand?.estatus;

        if (traz?.badge_texto) {
            let colorBg = '#e3f2fd';
            let colorTxt = '#1565c0';
            let borderC = '#bbdefb';
            let IconComponent = SentIcon;

            if (traz.estado_general === 'rechazado') {
                colorBg = '#ffebee';
                colorTxt = '#c62828';
                borderC = '#ffcdd2';
                IconComponent = RejectedIcon;
            } else if (traz.estado_general === 'completado') {
                colorBg = '#e8f5e9';
                colorTxt = '#2e7d32';
                borderC = '#c8e6c9';
                IconComponent = AcceptedIcon;
            } else if (traz.paso_actual === 2 || est === 'E3_ACEPTADA_AC') {
                colorBg = '#e0f7fa';
                colorTxt = '#00838f';
                borderC = '#b2ebf2';
                IconComponent = FactCheckIcon;
            } else if (traz.paso_actual === 3) {
                colorBg = '#fff3e0';
                colorTxt = '#ef6c00';
                borderC = '#ffe0b2';
                IconComponent = HourglassIcon;
            }

            return (
                <Box sx={{ display: 'inline-flex', alignItems: 'center', backgroundColor: colorBg, borderRadius: '15px', px: 1.2, py: 0.5, border: `1px solid ${borderC}` }}>
                    <IconComponent sx={{ color: colorTxt, fontSize: 16, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: colorTxt, fontWeight: 700, whiteSpace: 'nowrap' }}>
                        {traz.badge_texto}
                    </Typography>
                </Box>
            );
        }

        return (
            <Box sx={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#f5f5f5', borderRadius: '15px', px: 1, py: 0.5 }}>
                <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>{est || 'En Proceso'}</Typography>
            </Box>
        );
    };

    const getDocumentDownloadUrl = (doc) => {
        if (!doc) return '#';
        if (doc.url_archivo && (doc.url_archivo.startsWith('http://') || doc.url_archivo.startsWith('https://'))) {
            return doc.url_archivo;
        }
        if (doc.id_documento) {
            return `${hostInformacionComercial}Solicitud/documento/${doc.id_documento}`;
        }
        if (doc.nombre_archivo) {
            return `${hostInformacionComercial}Solicitud/archivo?nombre=${encodeURIComponent(doc.nombre_archivo)}`;
        }
        return '#';
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            if (userId) {
                try {
                    const clienteData = await dispatch(obtenerClienteByIdLogin(userId)).unwrap();
                    setCliente(clienteData?.cliente?.[0] || null);
                } catch (error) {
                    console.error("Error al obtener datos iniciales:", error);
                }
            }
        };
        fetchInitialData();
    }, [dispatch, userId]);

    const marcasCombinadas = [
        ...(cliente?.marcascliente?.map(m => ({ ...m, tipo: 'Mezcal' })) || []),
        ...(cliente?.marcasproductoconmezcalcliente?.map(m => ({ ...m, tipo: 'Bebida con Mezcal' })) || [])
    ];

    // Consulta paginada y con búsqueda en servidor (con debounce)
    useEffect(() => {
        if (!userId) return;

        const timer = setTimeout(() => {
            dispatch(obtenerSolicitudes({
                estatus: estatusFiltro,
                id_login: userId,
                search: searchTerm,
                page: page,
                limit: 10
            }));
        }, 300);

        return () => clearTimeout(timer);
    }, [dispatch, userId, estatusFiltro, searchTerm, page]);

    const handleRefresh = async () => {
        if (!userId) return;
        try {
            await Promise.all([
                dispatch(obtenerSolicitudes({
                    estatus: estatusFiltro,
                    id_login: userId,
                    search: searchTerm,
                    page: page,
                    limit: 10
                })).unwrap(),
                dispatch(obtenerClienteByIdLogin(userId)).unwrap().then(clienteData => {
                    setCliente(clienteData?.cliente?.[0] || null);
                }).catch(() => {})
            ]);

            Store.addNotification({
                title: "Tabla Actualizada",
                message: "Las solicitudes se han actualizado con éxito.",
                type: "info",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 3000, onScreen: true }
            });
        } catch (error) {
            console.error("Error al actualizar la tabla de solicitudes:", error);
            Store.addNotification({
                title: "Error al Actualizar",
                message: "No se pudieron refrescar los datos de la tabla.",
                type: "danger",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 4000, onScreen: true }
            });
        }
    };

    const solicitudesFiltradas = solicitudes || [];

    const getCountForFilter = (filterKey) => {
        if (!counts) return 0;
        switch (filterKey) {
            case 'TODOS': return counts.TODOS || 0;
            case 'E1_ENVIADA_ASOCIADO': return counts.E1_ENVIADA_ASOCIADO || 0;
            case 'E2_RECHAZADA_AC': return counts.E2_RECHAZADA_AC || 0;
            case 'E3_ACEPTADA_AC': return counts.E3_ACEPTADA_AC || 0;
            case 'E4_E5_REVISION_IC': return counts.E4_E5_REVISION_IC || 0;
            case 'E6_RECHAZADA_IC': return counts.E6_RECHAZADA_IC || 0;
            case 'E7_ACEPTADA_CON_INFORME': return counts.E7_ACEPTADA_CON_INFORME || 0;
            case 'E8_E9_UI': return counts.E8_E9_UI || 0;
            default: return 0;
        }
    };

    const handleSubmit = async () => {
        if (!formData.id_marca_cliente) {
            Store.addNotification({
                title: "Campo Requerido",
                message: "Por favor seleccione una marca.",
                type: "warning",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 5000, onScreen: true }
            });
            return;
        }

        if (!formData.tipoSolicitud) {
            Store.addNotification({
                title: "Campo Requerido",
                message: "Por favor seleccione el tipo de informe (Nacional o Exportación).",
                type: "warning",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 5000, onScreen: true }
            });
            return;
        }

        if (formData.tipoSolicitud === 'Exportación' && (!formData.pais || formData.pais.trim() === '')) {
            Store.addNotification({
                title: "Campo Requerido",
                message: "Por favor ingrese el país de destino para el informe de exportación.",
                type: "warning",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 5000, onScreen: true }
            });
            return;
        }

        if (!isEditing) {
            if (!formData.pagoPdf) {
                Store.addNotification({
                    title: "Documento Obligatorio",
                    message: "Es obligatorio adjuntar el Comprobante de Pago (PDF).",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });
                return;
            }

            if (!formData.etiquetasPdf) {
                Store.addNotification({
                    title: "Documento Obligatorio",
                    message: "Es obligatorio adjuntar el Juego de Etiquetas (PDF o imagen).",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });
                return;
            }
        }

        if (isEditing && selectedBrand) {
            // Modo EDICIÓN / CORRECCIÓN
            const data = new FormData();
            data.append('id_marca_cliente', formData.id_marca_cliente);
            data.append('tipo_informe', formData.tipoSolicitud);
            data.append('pais', formData.pais || '');
            data.append('comentarios_adicionales', formData.comentarios || '');
            data.append('cambio_presentacion', formData.motivos.cambioPresentacion);
            data.append('cambio_pais', formData.motivos.cambioPais);
            data.append('cambio_destino', formData.motivos.cambioDestino);
            data.append('otros', formData.motivos.otros);
            data.append('estatus', 'CORREGIDA');

            if (formData.pagoPdf) {
                data.append('COMPROBANTE_PAGO', formData.pagoPdf);
            }
            if (formData.etiquetasPdf) {
                data.append('JUEGO_ETIQUETAS', formData.etiquetasPdf);
            }

            try {
                await dispatch(actualizarSolicitud({
                    id_solicitud: selectedBrand.id_solicitud,
                    formData: data
                })).unwrap();

                Store.addNotification({
                    title: "¡Solicitud Corregida!",
                    message: "La solicitud ha sido corregida y re-enviada exitosamente a revisión.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });

                handleCloseModal();

                if (userId) {
                    dispatch(obtenerSolicitudes({
                        estatus: estatusFiltro,
                        id_login: userId,
                        search: searchTerm,
                        page: page,
                        limit: 10
                    }));
                }
            } catch (error) {
                console.error("Error al actualizar solicitud:", error);
                Store.addNotification({
                    title: "Error al Actualizar",
                    message: "Ocurrió un error al intentar actualizar la solicitud.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });
            }
        } else {
            // Modo CREACIÓN
            const data = new FormData();
            data.append('id_marca_cliente', formData.id_marca_cliente);
            data.append('tipo_informe', formData.tipoSolicitud);
            data.append('pais', formData.pais || '');
            data.append('comentarios_adicionales', formData.comentarios || '');
            data.append('cambio_presentacion', formData.motivos.cambioPresentacion);
            data.append('cambio_pais', formData.motivos.cambioPais);
            data.append('cambio_destino', formData.motivos.cambioDestino);
            data.append('otros', formData.motivos.otros);
            if (userId) data.append('id_login', userId);

            if (formData.pagoPdf) {
                data.append('COMPROBANTE_PAGO', formData.pagoPdf);
            }
            if (formData.etiquetasPdf) {
                data.append('JUEGO_ETIQUETAS', formData.etiquetasPdf);
            }

            try {
                await dispatch(registrarSolicitud(data)).unwrap();

                Store.addNotification({
                    title: "Solicitud Enviada",
                    message: "La solicitud de informe comercial se ha registrado con éxito.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });

                handleCloseModal();

                if (userId) {
                    dispatch(obtenerSolicitudes({
                        estatus: estatusFiltro,
                        id_login: userId,
                        search: searchTerm,
                        page: page,
                        limit: 10
                    }));
                }
            } catch (error) {
                console.error("Error al registrar solicitud:", error);
                Store.addNotification({
                    title: "Error al Enviar",
                    message: "Ocurrió un error al intentar enviar la solicitud.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    dismiss: { duration: 5000, onScreen: true }
                });
            }
        }
    };

    return (
        <div className='container2 animate__animated animate__fadeIn'>
            <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* --- HERO SECTION DE TRAZABILIDAD --- */}
                <Box sx={{
                    mb: 4,
                    p: { xs: 3, md: 4 },
                    borderRadius: 4,
                    background: 'linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 100%)',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 12px 35px rgba(0,0,0,0.2)'
                }}>
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                            <TimelineIcon sx={{ color: '#c88b3e', fontSize: 36 }} />
                            <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
                                Trazabilidad de Información Comercial
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ opacity: 0.85, fontWeight: 400, mb: 3, maxWidth: '750px', lineHeight: 1.5 }}>
                            Monitorea el ciclo de vida y dictamen técnico de tus etiquetas de Mezcal en tiempo real a través de cada etapa: Atención a Clientes, Evaluación Marcaria, Información Comercial y Unidad de Inspección.
                        </Typography>

                        {/* KPI Cards Rápidos en el Hero */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item xs={6} sm={3}>
                                <Paper sx={{ p: 2, backgroundColor: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(10px)', borderRadius: 2.5, border: '1px solid rgba(255,255,255,0.1)' }}>
                                    <Typography variant="caption" sx={{ color: '#ccc', display: 'block' }}>Total Registradas</Typography>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#ffffff' }}>
                                        {counts.TODOS || 0}
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper sx={{ p: 2, backgroundColor: 'rgba(2, 136, 209, 0.15)', backdropFilter: 'blur(10px)', borderRadius: 2.5, border: '1px solid rgba(2, 136, 209, 0.3)' }}>
                                    <Typography variant="caption" sx={{ color: '#81d4fa', display: 'block' }}>En Evaluación</Typography>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#29b6f6' }}>
                                        {(counts.E1_ENVIADA_ASOCIADO || 0) + (counts.E3_ACEPTADA_AC || 0) + (counts.E4_E5_REVISION_IC || 0)}
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper sx={{ p: 2, backgroundColor: 'rgba(211, 47, 47, 0.15)', backdropFilter: 'blur(10px)', borderRadius: 2.5, border: '1px solid rgba(211, 47, 47, 0.3)' }}>
                                    <Typography variant="caption" sx={{ color: '#ef9a9a', display: 'block' }}>Con Observaciones</Typography>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#ef5350' }}>
                                        {(counts.E2_RECHAZADA_AC || 0) + (counts.E6_RECHAZADA_IC || 0)}
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper sx={{ p: 2, backgroundColor: 'rgba(46, 125, 50, 0.15)', backdropFilter: 'blur(10px)', borderRadius: 2.5, border: '1px solid rgba(46, 125, 50, 0.3)' }}>
                                    <Typography variant="caption" sx={{ color: '#a5d6a7', display: 'block' }}>Aprobadas / Dictamen</Typography>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#66bb6a' }}>
                                        {(counts.E7_ACEPTADA_CON_INFORME || 0) + (counts.E8_E9_UI || 0)}
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>

                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={handleOpenModal}
                            sx={{
                                backgroundColor: '#c88b3e',
                                '&:hover': { backgroundColor: '#a67332', transform: 'translateY(-2px)' },
                                borderRadius: '30px',
                                px: 3.5,
                                py: 1.3,
                                fontWeight: 'bold',
                                fontSize: '0.95rem',
                                textTransform: 'none',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: '0 4px 15px rgba(200, 139, 62, 0.4)'
                            }}
                        >
                            Solicitar Nuevo Informe
                        </Button>
                    </Box>

                    {/* Decorative element */}
                    <Box sx={{
                        position: 'absolute',
                        right: -40,
                        top: -40,
                        width: 320,
                        height: 320,
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, rgba(200, 139, 62, 0.2) 0%, rgba(0,0,0,0) 70%)',
                        zIndex: 0
                    }} />
                </Box>

                {/* --- CONTENEDOR PRINCIPAL: TODAS LAS SOLICITUDES --- */}
                <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', backgroundColor: 'white' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#2b2b2b', display: 'flex', alignItems: 'center', gap: 1 }}>
                                Todas las Solicitudes
                                {counts?.TODOS !== undefined && (
                                    <Chip
                                        label={`${counts.TODOS} total`}
                                        size="small"
                                        sx={{ fontWeight: 700, fontSize: '0.75rem', backgroundColor: '#f0f0f0', color: '#555' }}
                                    />
                                )}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#777' }}>
                                Consulta y trazabilidad integral de expedientes registrados
                            </Typography>
                        </Box>

                        {/* Filtros: Select de Estatus y Buscador */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', width: { xs: '100%', md: 'auto' } }}>
                            <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 250 } }}>
                                <InputLabel id="filtro-estatus-select-label">Filtrar por estatus</InputLabel>
                                <Select
                                    labelId="filtro-estatus-select-label"
                                    id="filtro-estatus-select"
                                    value={estatusFiltro}
                                    label="Filtrar por estatus"
                                    onChange={(e) => handleFilterChange(e.target.value)}
                                    renderValue={(selected) => {
                                        const selectedFiltro = FILTROS_TRAZABILIDAD.find(f => f.key === selected);
                                        if (!selectedFiltro) return selected;
                                        const countNum = getCountForFilter(selectedFiltro.key);
                                        return (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {selectedFiltro.icon && React.cloneElement(selectedFiltro.icon, {
                                                    sx: { color: selectedFiltro.color, fontSize: 18 }
                                                })}
                                                <span>{selectedFiltro.label} ({countNum})</span>
                                            </Box>
                                        );
                                    }}
                                    sx={{
                                        borderRadius: '20px',
                                        backgroundColor: '#fafafa',
                                        fontSize: '0.85rem'
                                    }}
                                >
                                    {FILTROS_TRAZABILIDAD.map(filtro => {
                                        const countNum = getCountForFilter(filtro.key);
                                        const isSelected = estatusFiltro === filtro.key;
                                        return (
                                            <MenuItem key={filtro.key} value={filtro.key}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 2 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        {filtro.icon && React.cloneElement(filtro.icon, {
                                                            sx: { color: filtro.color, fontSize: 18 }
                                                        })}
                                                        <Typography variant="body2" sx={{ fontWeight: isSelected ? 700 : 500 }}>
                                                            {filtro.label}
                                                        </Typography>
                                                    </Box>
                                                    <Chip
                                                        label={countNum}
                                                        size="small"
                                                        sx={{
                                                            height: 20,
                                                            fontSize: '0.72rem',
                                                            fontWeight: 'bold',
                                                            backgroundColor: isSelected ? filtro.color : '#f0f0f0',
                                                            color: isSelected ? '#ffffff' : '#666'
                                                        }}
                                                    />
                                                </Box>
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>

                            <TextField
                                size="small"
                                placeholder="Buscar por marca, folio, RFC..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ color: '#999', fontSize: 20 }} />
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: '20px', minWidth: { xs: '100%', sm: 260 }, backgroundColor: '#fafafa' }
                                }}
                                sx={{ width: { xs: '100%', sm: 'auto' } }}
                            />

                            <Tooltip title="Actualizar datos de la tabla" arrow>
                                <span>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={handleRefresh}
                                        disabled={loadingInfo}
                                        startIcon={
                                            <RefreshIcon
                                                sx={{
                                                    fontSize: 19,
                                                    animation: loadingInfo ? 'spin 1s linear infinite' : 'none',
                                                    '@keyframes spin': {
                                                        '0%': { transform: 'rotate(0deg)' },
                                                        '100%': { transform: 'rotate(360deg)' }
                                                    }
                                                }}
                                            />
                                        }
                                        sx={{
                                            borderRadius: '20px',
                                            borderColor: '#c88b3e',
                                            color: '#c88b3e',
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            fontSize: '0.85rem',
                                            height: 40,
                                            px: 2.2,
                                            backgroundColor: 'rgba(200, 139, 62, 0.04)',
                                            '&:hover': {
                                                borderColor: '#a67332',
                                                backgroundColor: 'rgba(200, 139, 62, 0.12)',
                                                transform: 'translateY(-1px)'
                                            },
                                            transition: 'all 0.2s ease',
                                            '&.Mui-disabled': {
                                                borderColor: '#e0e0e0',
                                                color: '#aaa'
                                            }
                                        }}
                                    >
                                        {loadingInfo ? 'Actualizando...' : 'Actualizar'}
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    {/* --- TABLA DE TRAZABILIDAD INTEGRAL --- */}
                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eef0f2', borderRadius: 3, overflowX: 'auto', position: 'relative' }}>
                        {loadingInfo && (
                            <LinearProgress
                                sx={{
                                    height: 3,
                                    backgroundColor: '#f5efe6',
                                    '& .MuiLinearProgress-bar': { backgroundColor: '#c88b3e' }
                                }}
                            />
                        )}
                        <Table sx={{ minWidth: 950 }}>
                            <TableHead sx={{ backgroundColor: '#fcfcfc' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Folio & Fecha</TableCell>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Marca & Registro</TableCell>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Tipo / Destino</TableCell>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem', minWidth: 220 }}>Trazabilidad & Avance</TableCell>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Estatus Actual</TableCell>
                                    <TableCell sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Ejecutivo Asignado</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 800, color: '#444', fontSize: '0.85rem' }}>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {solicitudesFiltradas && solicitudesFiltradas.length > 0 ? (
                                    solicitudesFiltradas.map((brand, index) => {
                                        const rechazada = isSolicitudRechazada(brand);
                                        const obsRechazo = getObservacionesRechazo(brand);
                                        const traz = brand.trazabilidad || {};
                                        const pct = traz.porcentaje_avance || 25;
                                        const fechaFormato = brand.fecha_creacion ? new Date(brand.fecha_creacion).toLocaleDateString() : '-';

                                        return (
                                            <TableRow
                                                key={brand.id_solicitud || index}
                                                sx={{
                                                    backgroundColor: rechazada ? '#fffbfb' : '#ffffff',
                                                    '&:hover': { backgroundColor: rechazada ? '#fff5f5' : '#fbf8f3' },
                                                    transition: 'background-color 0.2s',
                                                    borderLeft: rechazada ? '5px solid #f44336' : (pct >= 85 ? '5px solid #2e7d32' : '5px solid #c88b3e')
                                                }}
                                            >
                                                {/* 1. Folio & Fecha */}
                                                <TableCell>
                                                    <Typography variant="body2" sx={{ fontWeight: 800, fontFamily: 'monospace', color: '#2b2b2b' }}>
                                                        {brand.folio || `INF-${brand.id_solicitud}`}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#888', display: 'block' }}>
                                                        {fechaFormato}
                                                    </Typography>
                                                </TableCell>

                                                {/* 2. Marca & Registro */}
                                                <TableCell>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1a1a1a', lineHeight: 1.2 }}>
                                                        {brand.nombre_marca || brand.marca || 'Marca sin identificar'}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mt: 0.5 }}>
                                                        <Typography variant="caption" sx={{ color: '#c88b3e', fontWeight: 700, fontFamily: 'monospace', fontSize: '0.7rem' }}>
                                                            IMPI: {brand.numeroderegistroimpi || brand.noRegistroIMPI || 'En trámite'}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>

                                                {/* 3. Tipo / Destino */}
                                                <TableCell>
                                                    <Chip
                                                        label={brand.tipo_informe === 'Exportaci_n' ? 'Exportación' : (brand.tipo_informe || 'Nacional')}
                                                        size="small"
                                                        color={brand.tipo_informe && brand.tipo_informe.includes('Export') ? 'warning' : 'default'}
                                                        sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700 }}
                                                    />
                                                    {brand.pais && (
                                                        <Typography variant="caption" sx={{ color: '#666', display: 'block', fontWeight: 600, mt: 0.3 }}>
                                                            {brand.pais}
                                                        </Typography>
                                                    )}
                                                </TableCell>

                                                {/* 4. Trazabilidad & Avance */}
                                                <TableCell>
                                                    <Box sx={{ minWidth: 180 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                            <Typography variant="caption" sx={{ fontWeight: 800, color: rechazada ? '#d32f2f' : '#555' }}>
                                                                {traz.fase_actual || 'Evaluación'}
                                                            </Typography>
                                                            <Typography variant="caption" sx={{ fontWeight: 800, color: rechazada ? '#d32f2f' : '#c88b3e' }}>
                                                                {pct}%
                                                            </Typography>
                                                        </Box>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={pct}
                                                            sx={{
                                                                height: 6,
                                                                borderRadius: 3,
                                                                backgroundColor: '#e8e8e8',
                                                                '& .MuiLinearProgress-bar': {
                                                                    backgroundColor: rechazada ? '#f44336' : (pct >= 85 ? '#2e7d32' : '#c88b3e'),
                                                                    borderRadius: 3
                                                                },
                                                                mb: 1
                                                            }}
                                                        />
                                                        {/* Mini Stepper 4 Nodos */}
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 0.5 }}>
                                                            {traz.etapas?.map((etapa, eIdx) => {
                                                                const isDone = etapa.estado === 'completado';
                                                                const isAct = etapa.estado === 'activo';
                                                                const isRej = etapa.estado === 'rechazado';

                                                                let dotColor = '#ccc';
                                                                if (isDone) dotColor = '#2e7d32';
                                                                else if (isAct) dotColor = '#0288d1';
                                                                else if (isRej) dotColor = '#d32f2f';

                                                                return (
                                                                    <Tooltip key={eIdx} title={`${etapa.titulo} (${etapa.estado})`} arrow>
                                                                        <Box sx={{
                                                                            width: isAct || isRej ? 14 : 10,
                                                                            height: isAct || isRej ? 14 : 10,
                                                                            borderRadius: '50%',
                                                                            backgroundColor: dotColor,
                                                                            border: isAct ? '2px solid #0288d1' : (isRej ? '2px solid #d32f2f' : 'none'),
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover': { transform: 'scale(1.3)' }
                                                                        }} />
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </Box>
                                                    </Box>
                                                </TableCell>

                                                {/* 5. Estatus Actual */}
                                                <TableCell>
                                                    {getStatusBadge(brand)}
                                                    {rechazada && obsRechazo && (
                                                        <Tooltip title={obsRechazo} arrow>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, color: '#d32f2f', cursor: 'pointer' }}>
                                                                <ErrorIcon sx={{ fontSize: 14 }} />
                                                                <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.7rem' }}>
                                                                    Observación pendiente
                                                                </Typography>
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </TableCell>

                                                {/* 6. Revisor Asignado */}
                                                <TableCell>
                                                    <Typography variant="body2" sx={{ color: '#444', fontWeight: 600, fontSize: '0.85rem' }}>
                                                        {brand.revisor || 'En asignación'}
                                                    </Typography>
                                                </TableCell>

                                                {/* 7. Acciones */}
                                                <TableCell align="center">
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                        <Tooltip title="Ver Trazabilidad y Detalle" arrow>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleOpenDetailModal(brand)}
                                                                sx={{
                                                                    color: '#c88b3e',
                                                                    backgroundColor: 'rgba(200, 139, 62, 0.08)',
                                                                    '&:hover': { backgroundColor: 'rgba(200, 139, 62, 0.2)' }
                                                                }}
                                                            >
                                                                <TimelineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>

                                                        {rechazada && (
                                                            <Tooltip title="Corregir Solicitud Rechazada" arrow>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleEditRequest(brand)}
                                                                    sx={{
                                                                        color: '#f44336',
                                                                        backgroundColor: 'rgba(244, 67, 54, 0.1)',
                                                                        '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.25)' }
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                                            <TimelineIcon sx={{ fontSize: 48, opacity: 0.25, color: '#c88b3e', mb: 1 }} />
                                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#555' }}>
                                                No se encontraron solicitudes con el filtro ({FILTROS_TRAZABILIDAD.find(f => f.key === estatusFiltro)?.label || estatusFiltro})
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#888', display: 'block', mb: 2 }}>
                                                Selecciona otro filtro de estatus, registra una nueva solicitud o recarga la información de la tabla.
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                startIcon={<RefreshIcon />}
                                                onClick={handleRefresh}
                                                disabled={loadingInfo}
                                                sx={{
                                                    borderRadius: '20px',
                                                    borderColor: '#c88b3e',
                                                    color: '#c88b3e',
                                                    textTransform: 'none',
                                                    fontWeight: 700,
                                                    px: 2.5,
                                                    '&:hover': {
                                                        borderColor: '#a67332',
                                                        backgroundColor: 'rgba(200, 139, 62, 0.08)'
                                                    }
                                                }}
                                            >
                                                Actualizar Tabla
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {pagination && (
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3, pt: 2, borderTop: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 2 }}>
                            <Typography variant="caption" sx={{ color: '#777', fontWeight: 600 }}>
                                Mostrando página <strong>{pagination.page || page}</strong> de <strong>{pagination.totalPages || 1}</strong> ({pagination.total || 0} expedientes totales)
                            </Typography>
                            {pagination.totalPages > 1 && (
                                <Pagination
                                    count={pagination.totalPages}
                                    page={page}
                                    onChange={(e, val) => setPage(val)}
                                    color="primary"
                                    shape="rounded"
                                    sx={{
                                        '& .Mui-selected': { backgroundColor: '#c88b3e !important', color: 'white' }
                                    }}
                                />
                            )}
                        </Box>
                    )}
                </Paper>

                {/* =====================================================================
                    MODAL DE REGISTRO / EDICIÓN Y CORRECCIÓN DE SOLICITUD
                ===================================================================== */}
                <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
                    <DialogTitle sx={{
                        backgroundColor: isEditing ? '#fff8e1' : '#fcfcfc',
                        borderBottom: '1px solid #e0e0e0',
                        p: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <BrandIcon sx={{ color: isEditing ? '#f57c00' : '#c88b3e', fontSize: 28 }} />
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                                    {isEditing ? `Corregir Solicitud (${selectedBrand?.folio || 'Expediente'})` : 'Nueva Solicitud de Información Comercial'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#666' }}>
                                    {isEditing ? 'Modifique los campos observados y reemplace los documentos necesarios.' : 'Complete el formulario para iniciar la revisión de sus etiquetas.'}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={handleCloseModal} size="small">
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent sx={{ p: 4 }}>
                        {/* ALERTA VISUAL DE OBSERVACIONES DE RECHAZO EN EL FORMULARIO DE EDICIÓN */}
                        {isEditing && selectedBrand && isSolicitudRechazada(selectedBrand) && (
                            <Alert
                                severity="error"
                                icon={<ReportProblemIcon fontSize="inherit" />}
                                sx={{ mb: 3, borderRadius: 2, border: '1px solid #ef9a9a' }}
                            >
                                <AlertTitle sx={{ fontWeight: 800 }}>
                                    Observaciones de Rechazo ({getEtapaRechazoLabel(selectedBrand.estatus)}):
                                </AlertTitle>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {getObservacionesRechazo(selectedBrand) || 'Por favor revise y corrija los datos o documentos señalados.'}
                                </Typography>
                            </Alert>
                        )}

                        <Grid container spacing={3}>
                            {/* Sección: Información General */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                    <InfoIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        INFORMACIÓN GENERAL
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Marca *"
                                    name="id_marca_cliente"
                                    value={formData.id_marca_cliente}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    helperText="Seleccione la marca registrada"
                                >
                                    {marcasCombinadas.map((marca, idx) => (
                                        <MenuItem
                                            key={marca.idmarcascliente || marca.idmarcasproductocliente || idx}
                                            value={marca.idmarcascliente || marca.idmarcasproductocliente}
                                        >
                                            {marca.marca} ({marca.tipo})
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Tipo de Informe *"
                                    name="tipoSolicitud"
                                    value={formData.tipoSolicitud}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                >
                                    <MenuItem value="Nacional">Nacional</MenuItem>
                                    <MenuItem value="Exportación">Exportación</MenuItem>
                                </TextField>
                            </Grid>

                            {formData.tipoSolicitud === 'Exportación' && (
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="País de Destino *"
                                        name="pais"
                                        placeholder="Ej. Estados Unidos, España, Japón..."
                                        value={formData.pais}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        required
                                    />
                                </Grid>
                            )}

                            {/* Sección: Motivos de Revisión */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <SectionIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        MOTIVO DE REVISIÓN
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                                <FormGroup>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.motivos.cambioPresentacion} onChange={handleCheckboxChange} name="cambioPresentacion" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                label={<Typography variant="body2">Cambio de presentación</Typography>}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.motivos.cambioPais} onChange={handleCheckboxChange} name="cambioPais" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                label={<Typography variant="body2">Cambio de país</Typography>}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.motivos.cambioDestino} onChange={handleCheckboxChange} name="cambioDestino" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                label={<Typography variant="body2">Cambio de destino</Typography>}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.motivos.otros} onChange={handleCheckboxChange} name="otros" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                label={<Typography variant="body2">Otros</Typography>}
                                            />
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </Grid>

                            {/* Sección: Documentación y Adjuntos */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <UploadIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        DOCUMENTACIÓN Y ADJUNTOS {isEditing ? '(SELECCIONE PARA REEMPLAZAR)' : '(OBLIGATORIOS)'}
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    startIcon={<UploadIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        justifyContent: 'flex-start',
                                        borderColor: formData.pagoPdf ? '#4caf50' : '#e0e0e0',
                                        backgroundColor: formData.pagoPdf ? 'rgba(76, 175, 80, 0.05)' : 'transparent',
                                        color: '#333',
                                        py: 1.5,
                                        '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' }
                                    }}
                                >
                                    <Box sx={{ textAlign: 'left', width: '100%' }}>
                                        <Typography variant="caption" display="block" color={formData.pagoPdf ? 'success.main' : 'textSecondary'} sx={{ fontWeight: 'bold' }}>
                                            Comprobante de Pago (PDF) * {formData.pagoPdf ? '✓ Archivo Seleccionado' : (isEditing ? '(Conservar actual o subir nuevo)' : '(Obligatorio)')}
                                        </Typography>
                                        <Typography variant="body2" noWrap sx={{ color: formData.pagoPdf ? '#2e7d32' : '#333', fontWeight: formData.pagoPdf ? 'bold' : 'normal' }}>
                                            {formData.pagoPdf ? formData.pagoPdf.name : 'Subir archivo PDF del comprobante...'}
                                        </Typography>
                                    </Box>
                                    <input type="file" hidden accept="application/pdf" name="pagoPdf" onChange={handleFileChange} />
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    startIcon={<UploadIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        justifyContent: 'flex-start',
                                        borderColor: formData.etiquetasPdf ? '#4caf50' : '#e0e0e0',
                                        backgroundColor: formData.etiquetasPdf ? 'rgba(76, 175, 80, 0.05)' : 'transparent',
                                        color: '#333',
                                        py: 1.5,
                                        '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' }
                                    }}
                                >
                                    <Box sx={{ textAlign: 'left', width: '100%' }}>
                                        <Typography variant="caption" display="block" color={formData.etiquetasPdf ? 'success.main' : 'textSecondary'} sx={{ fontWeight: 'bold' }}>
                                            Juego de Etiquetas (PDF/Imagen) * {formData.etiquetasPdf ? '✓ Archivo Seleccionado' : (isEditing ? '(Conservar actual o subir nuevo)' : '(Obligatorio)')}
                                        </Typography>
                                        <Typography variant="body2" noWrap sx={{ color: formData.etiquetasPdf ? '#2e7d32' : '#333', fontWeight: formData.etiquetasPdf ? 'bold' : 'normal' }}>
                                            {formData.etiquetasPdf ? formData.etiquetasPdf.name : 'Subir diseño de etiquetas corregido...'}
                                        </Typography>
                                    </Box>
                                    <input type="file" hidden accept="application/pdf,image/*" name="etiquetasPdf" onChange={handleFileChange} />
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Comentarios o Respuestas a la Corrección"
                                    name="comentarios"
                                    placeholder="Describa los cambios realizados o aclaraciones respecto al rechazo..."
                                    value={formData.comentarios}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
                        <Button onClick={handleCloseModal} sx={{ color: '#666', fontWeight: 'bold', textTransform: 'none' }}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: isEditing ? '#f44336' : '#2b2b2b',
                                '&:hover': { backgroundColor: isEditing ? '#d32f2f' : '#444' },
                                borderRadius: '25px',
                                px: 4,
                                textTransform: 'none',
                                fontWeight: 'bold'
                            }}
                        >
                            {isEditing ? 'Re-enviar Solicitud Corregida' : 'Registrar Solicitud'}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* =====================================================================
                    MODAL DE DETALLE Y TRAZABILIDAD INTEGRAL DEL EXPEDIENTE
                ===================================================================== */}
                <Dialog open={openDetailModal} onClose={handleCloseDetailModal} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3.5 } }}>
                    <DialogTitle sx={{
                        backgroundColor: isSolicitudRechazada(selectedBrand) ? '#fff5f5' : '#fcfcfc',
                        borderBottom: isSolicitudRechazada(selectedBrand) ? '1px solid #ffcdd2' : '1px solid #e0e0e0',
                        p: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <TimelineIcon sx={{ color: isSolicitudRechazada(selectedBrand) ? '#c62828' : '#c88b3e', fontSize: 34 }} />
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                                    Trazabilidad: {selectedBrand?.nombre_marca || selectedBrand?.marca || 'Expediente'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#666', fontFamily: 'monospace' }}>
                                    Folio: {selectedBrand?.folio || `INF-${selectedBrand?.id_solicitud}`} • Tipo: {selectedBrand?.tipo_informe === 'Exportaci_n' ? 'Exportación' : (selectedBrand?.tipo_informe || 'Nacional')}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={handleCloseDetailModal} size="small">
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent sx={{ p: 4 }}>
                        {selectedBrand && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                {/* BLOQUE DESTACADO DE OBSERVACIONES DE RECHAZO (SI APLICA) */}
                                {isSolicitudRechazada(selectedBrand) && (
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            borderRadius: 3,
                                            border: '1.5px solid #ef5350',
                                            borderLeft: '8px solid #d32f2f',
                                            backgroundColor: '#fff8f8'
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, flexWrap: 'wrap', gap: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <ReportProblemIcon sx={{ color: '#d32f2f', fontSize: 24 }} />
                                                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#c62828' }}>
                                                    OBSERVACIONES DE RECHAZO ({getEtapaRechazoLabel(selectedBrand.estatus)})
                                                </Typography>
                                            </Box>
                                            <Chip
                                                label="Acción Requerida: Corregir Solicitud"
                                                size="small"
                                                color="error"
                                                sx={{ fontWeight: 700 }}
                                            />
                                        </Box>

                                        <Typography variant="body1" sx={{ color: '#212121', backgroundColor: '#ffffff', p: 2, borderRadius: 2, border: '1px solid #ffcdd2', fontWeight: 500, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                                            {getObservacionesRechazo(selectedBrand) || 'No se registraron observaciones detalladas. Por favor póngase en contacto con su ejecutivo asignado.'}
                                        </Typography>

                                        {selectedBrand.revisor && (
                                            <Box sx={{ mt: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="caption" sx={{ color: '#777', fontWeight: 600 }}>
                                                    Emitido por: <strong>{selectedBrand.revisor}</strong>
                                                </Typography>
                                            </Box>
                                        )}
                                    </Paper>
                                )}

                                {/* STEPPER DE TRAZABILIDAD COMPLETO POR FASES */}
                                <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, backgroundColor: '#fcfcfc' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#2b2b2b', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <TimelineIcon sx={{ color: '#c88b3e' }} /> CICLO DE EVALUACIÓN Y TRAZABILIDAD
                                        </Typography>
                                        <Chip
                                            label={`${selectedBrand.trazabilidad?.porcentaje_avance || 25}% de avance`}
                                            size="small"
                                            sx={{ fontWeight: 700, backgroundColor: '#c88b3e', color: 'white' }}
                                        />
                                    </Box>

                                    <Stepper orientation="vertical">
                                        {selectedBrand.trazabilidad?.etapas?.map((etapa, idx) => {
                                            const isDone = etapa.estado === 'completado';
                                            const isAct = etapa.estado === 'activo';
                                            const isRej = etapa.estado === 'rechazado';

                                            let stepColor = '#bbb';
                                            let icon = <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#bbb' }} />;
                                            if (isDone) {
                                                stepColor = '#2e7d32';
                                                icon = <AcceptedIcon sx={{ color: '#2e7d32', fontSize: 24 }} />;
                                            } else if (isAct) {
                                                stepColor = '#0288d1';
                                                icon = <HourglassIcon sx={{ color: '#0288d1', fontSize: 24 }} />;
                                            } else if (isRej) {
                                                stepColor = '#d32f2f';
                                                icon = <RejectedIcon sx={{ color: '#d32f2f', fontSize: 24 }} />;
                                            }

                                            return (
                                                <Step key={idx} active={isAct} completed={isDone}>
                                                    <StepLabel
                                                        StepIconComponent={() => icon}
                                                        optional={
                                                            <Typography variant="caption" sx={{ color: '#777' }}>
                                                                Responsable: {etapa.responsable}
                                                            </Typography>
                                                        }
                                                    >
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: stepColor }}>
                                                            {etapa.titulo} • {etapa.subtitulo}
                                                        </Typography>
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Typography variant="body2" sx={{ color: '#555', mb: 1 }}>
                                                            {etapa.descripcion}
                                                        </Typography>
                                                        {etapa.observaciones && (
                                                            <Paper sx={{ p: 1.5, backgroundColor: isRej ? '#ffebee' : '#f5f5f5', borderRadius: 1.5, border: '1px solid #e0e0e0', mb: 1 }}>
                                                                <Typography variant="caption" sx={{ fontWeight: 700, color: isRej ? '#c62828' : '#444', display: 'block' }}>
                                                                    Observaciones registradas:
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.8rem', color: isRej ? '#b71c1c' : '#333' }}>
                                                                    {etapa.observaciones}
                                                                </Typography>
                                                            </Paper>
                                                        )}
                                                    </StepContent>
                                                </Step>
                                            );
                                        })}
                                    </Stepper>
                                </Paper>

                                {/* DATOS GENERALES DEL ASOCIADO Y MARCA */}
                                <Paper variant="outlined" sx={{ p: 3, borderRadius: 2.5 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <InfoIcon fontSize="small" sx={{ color: '#c88b3e' }} /> INFORMACIÓN DE LA MARCA Y ASOCIADO
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">Razón Social</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{selectedBrand.asociado || selectedBrand.nombrerazonsocial || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">No. de Socio / ID</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>{selectedBrand.noAsociado || selectedBrand.numerosocio || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">RFC</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>{selectedBrand.rfc || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">Registro IMPI</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', fontFamily: 'monospace', color: '#c88b3e' }}>{selectedBrand.noRegistroIMPI || selectedBrand.numeroderegistroimpi || 'En trámite'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">Titularidad</Typography>
                                            <Typography variant="body2">{selectedBrand.titularidad || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block">Tipo de Signo Distintivo</Typography>
                                            <Typography variant="body2">{selectedBrand.tipo_signo_marca || 'Nominativa'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>

                                {/* DOCUMENTOS ADJUNTOS */}
                                <Paper variant="outlined" sx={{ p: 3, borderRadius: 2.5 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <FileIcon fontSize="small" sx={{ color: '#c88b3e' }} /> DOCUMENTACIÓN ADJUNTA
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {(selectedBrand.solicitud_documentacion || selectedBrand.archivos || []).map((doc, idx) => (
                                            <Grid item xs={12} sm={6} key={idx}>
                                                <Paper
                                                    elevation={0}
                                                    component="a"
                                                    href={getDocumentDownloadUrl(doc)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{
                                                        p: 2,
                                                        border: '1px solid #e0e0e0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 2,
                                                        textDecoration: 'none',
                                                        color: 'inherit',
                                                        borderRadius: 2,
                                                        transition: 'all 0.2s',
                                                        '&:hover': { borderColor: '#c88b3e', backgroundColor: '#fcfcfc', transform: 'translateY(-2px)' }
                                                    }}
                                                >
                                                    <FileIcon sx={{ color: '#c88b3e', fontSize: 32 }} />
                                                    <Box sx={{ overflow: 'hidden' }}>
                                                        <Typography variant="caption" color="textSecondary" display="block">
                                                            {doc.tipo_documento === 'COMPROBANTE_PAGO' || doc.tipo === 'COMPROBANTE_PAGO' ? 'Comprobante de Pago' : 'Juego de Etiquetas'}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }} noWrap>
                                                            {doc.nombre_archivo || doc.nombre || 'Documento'}
                                                        </Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        ))}
                                        {(!selectedBrand.solicitud_documentacion || selectedBrand.solicitud_documentacion.length === 0) && (!selectedBrand.archivos || selectedBrand.archivos.length === 0) && (
                                            <Grid item xs={12}>
                                                <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                                                    No hay documentos adjuntos registrados.
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Paper>

                                {/* COMENTARIOS ADICIONALES */}
                                {selectedBrand.comentarios_adicionales && (
                                    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2.5, backgroundColor: '#fcfcfc' }}>
                                        <Typography variant="caption" color="textSecondary" display="block" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                            COMENTARIOS DEL SOLICITANTE:
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#444' }}>
                                            {selectedBrand.comentarios_adicionales}
                                        </Typography>
                                    </Paper>
                                )}
                            </Box>
                        )}
                    </DialogContent>

                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9', display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={handleCloseDetailModal} sx={{ color: '#666', fontWeight: 'bold', textTransform: 'none' }}>
                            Cerrar
                        </Button>

                        {isSolicitudRechazada(selectedBrand) && (
                            <Button
                                onClick={() => handleEditRequest(selectedBrand)}
                                variant="contained"
                                startIcon={<EditIcon />}
                                sx={{
                                    backgroundColor: '#f44336',
                                    '&:hover': { backgroundColor: '#d32f2f' },
                                    borderRadius: '25px',
                                    px: 4,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
                                }}
                            >
                                Corregir y Re-enviar Solicitud
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </Box>
        </div>
    );
};

export default InformacionComercial;
